<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="日期" prop="holiday">
        <el-date-picker v-model="form.holiday" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaHolidaysWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        holiday: ''
      },
      // 验证规则
      rules: {
        holiday: [
          { required: true, message: '请选择日期', tigger: 'change' },
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/holidays',
      'field.id': 'id'
    })
  }
}
</script>
